<div class="badges-wrapper">
  <mat-slide-toggle
    [checked]="useBadgesEnabled"
    (change)="toggleUseBadges($event.checked)"
    color="primary">
    {{ 'badges.header' | translate }}
  </mat-slide-toggle>

  <div class="badges-content-wrapper" *ngIf="useBadgesEnabled">
    <div class="badges-grid">
      <div
        class="badge-item"
        *ngFor="let b of badges"
        [class.selected]="isSelected(b)"
        (click)="toggle(b)"
        role="button"
        [attr.aria-pressed]="isSelected(b)"
        tabindex="0"
        [matTooltip]="getBadgeDescription(b)">
        <div class="badge-image-wrapper">
          <img [src]="b.url" [alt]="getBadgeTitle(b)" />
          <mat-icon class="check-icon" *ngIf="isSelected(b)">check_circle</mat-icon>
        </div>
        <span class="badge-title">
          {{ getBadgeTitle(b) }}
        </span>
      </div>
    </div>

    <div class="badges-actions">
      <button
        type="button"
        mat-stroked-button
        (click)="openAddBadgeDialog()">
        <mat-icon>add</mat-icon>
        <span>{{ 'badges.add' | translate }}</span>
      </button>
    </div>
  </div>
</div>
